<template>
  <div
    v-if="visible && $store.getters.currentTheme"
    id="loading-overlay"
    class="period"
  >
    <div class="loading">
      <img
        class="c01"
        :src="$getThemeImagePath('LogoLoading_circle01.png')"
        alt=""
      >
      <img
        class="c02"
        :src="$getThemeImagePath('LogoLoading_circle02.png')"
        alt=""
      >
      <img
        class="shinelight"
        :src="$getThemeImagePath('logo-2.webp')"
        alt=""
      >
    </div>
  </div>
</template>

<script>
import { isPublicRoute } from '@/utils/tool'

// 計數歸零後延遲收起：連續請求之間 loadingCount 會短暫 1→0→1，
// 若立即卸載再重建，轉圈動畫會從頭開始，看起來就是卡頓
const HIDE_DELAY = 150
// theme_gold 公開頁：請求持續 pending 時遮罩最多顯示這麼久，逾時就收起讓正文可讀（請求照跑，不中斷）
const MAX_VISIBLE = 10000

export default {
  name: 'Loading',
  data() {
    return {
      visible: this.$store.state.app.loadingCount > 0,
      hideTimer: null,
      maxTimer: null
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.app.loadingCount > 0
    }
  },
  watch: {
    isLoading(loading) {
      clearTimeout(this.hideTimer)
      if (loading) {
        this.visible = true
        this.startMaxTimer()
      } else {
        this.hideTimer = setTimeout(() => {
          this.visible = false
          clearTimeout(this.maxTimer)
          this.maxTimer = null
        }, HIDE_DELAY)
      }
    }
  },
  created() {
    if (this.visible) this.startMaxTimer()
  },
  beforeDestroy() {
    clearTimeout(this.hideTimer)
    clearTimeout(this.maxTimer)
  },
  methods: {
    // 從開始轉圈起算，計數短暫歸零又加回（遮罩沒收起）的不重算
    startMaxTimer() {
      if (process.env.VUE_APP_THEME !== 'theme_gold' || this.maxTimer) return
      this.maxTimer = setTimeout(() => {
        if (isPublicRoute(this.$route)) this.visible = false
      }, MAX_VISIBLE)
    }
  }
}
</script>

<style scoped>

.loading {
	width: 180px;
	height: 180px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.period .loading img {
	position: absolute;
}

.c01 {
	animation: spin 3.333s linear infinite;
}

.c02 {
	animation: spin2 2.666s linear infinite;
}

.shinelight {
	max-width: 180px;
	height: auto;
}

@keyframes spin {
	0% {
		opacity: 1;
		transform: rotate(0deg);
	}
	50% {
		opacity: 0;
		transform: rotate(180deg);
	}
	100% {
		opacity: 1;
		transform: rotate(360deg);
	}
}

@keyframes spin2 {
	0% {
		opacity: 0;
		transform: rotate(0deg);
	}
	50% {
		opacity: 1;
		transform: rotate(-180deg);
	}
	100% {
		opacity: 0;
		transform: rotate(-360deg);
	}
}

@keyframes slide {
	0% {
		transform: translateX(-100%);
	}
	100% {
		transform: translateX(100%);
	}
}

#loading-overlay {
  position: fixed;
  background-color: rgba(225, 225, 225, .9); /* fallback：不支援 color-mix 的舊核心維持現狀 */
  /* 遮罩底色由各 theme 的 --bg-primary 推導 92% 不透明；--loading-overlay-bg 為選配覆寫口 */
  background-color: var(--loading-overlay-bg, color-mix(in srgb, var(--bg-primary) 92%, transparent));
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1030;
  overflow-y: hidden;
}
</style>
